
import Portfolio from './portfolio';

function App() {
  return (
    <div className="App">
     <Portfolio/>
    </div>
  );
}

export default App;
